export const AI_APP_NAMES = {
  PICK_MY_CALL: 'pickmycallfree',
  AI_RECEPTIONIST: 'aireceptionist',
};
export const AVAILABILITY_OPTIONS = {
  ALWAYS: 'ALWAYS',
  WORK_HOURS: 'WORK_HOURS',
  NEVER: 'NEVER',
};
export const STEPS = {
  CHOOSE_NUMBER_STEP: 1,
  CLAIM_NUMBER_STEP: 2,
};
export const POLLING_DELAY_MS = 1000;
export const POLLING_TIMEOUT_MS = 20000;
export const DEFAULT_COUNTRY_CODE = 'US';
export const DEFAULT_PAGE_SIZE = 7;
export const AREA_CODE_LENGTH = 3;
export const NUMBER_TYPES = {
  LOCAL: 'local',
  TOLL_FREE: 'toll_free',
};
export const FEATURE_SETS = {
  LOCAL: ['VOICE'],
  TOLL_FREE: ['VOICE'],
};
export const US_TOLL_FREE_AREA_CODES = ['800', '833', '844', '855', '866', '877', '888'];
export const MISSED_CALL_OPTIONS = {
  MISSED_CALL: 'MISSED_CALL',
  VOICEMAIL: 'VOICEMAIL',
};
